import { render, staticRenderFns } from "./IdHistory.vue?vue&type=template&id=6428fae5&"
import script from "./IdHistory.vue?vue&type=script&lang=js&"
export * from "./IdHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports